var _g, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwinkle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffda2d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m271 0h-30c0 66.299-53.699 121-120 121v30c66.301 0 120 53.699 120 120h30c0-66.301 53.699-120 120-120v-30c-66.301 0-120-54.701-120-121z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391 301h-30c0 49.499-40.499 90-90 90v30c49.501 0 90 41.499 90 91h30c0-49.501 40.499-91 90-91v-30c-49.501 0-90-40.501-90-90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121 241h-30c0 32.999-27.001 60-60 60v30c32.999 0 60 26.999 60 60h30c0-33.001 27.001-60 60-60v-30c-32.999 0-60-27.001-60-60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181 421h30v30h-30z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m421 241h30v30h-30z",
    fill: "#fdbf00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m61 61h30v30h-30z",
    fill: "#ffda2d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m361 0h30v30h-30z",
    fill: "#fdbf00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m181 301v30c-32.999 0-60 26.999-60 60h-15v-150h15c0 32.999 27.001 60 60 60z",
    fill: "#fdbf00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m391 121v30c-66.301 0-120 53.699-120 120h-15v-271h15c0 66.299 53.699 121 120 121z",
    fill: "#fdbf00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m481 391v30c-49.501 0-90 41.499-90 91h-15v-211h15c0 49.499 40.499 90 90 90z",
    fill: "#fdbf00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle);
export default __webpack_public_path__ + "static/media/twinkle.c1725bc0.svg";
export { ForwardRef as ReactComponent };